import { Box, Column, Row, Text } from '@te-whatu-ora/anatomic'
import type {
  CodeSystemPropertyValue,
  TerminologyDisplayInputProps
} from '@healthnz-prm/fhir-engine-renderer/types'

function formatValue(value: CodeSystemPropertyValue): string {
  if (typeof value === 'boolean') return value ? 'Yes' : 'No'
  return String(value)
}

// Properties looked up from a CodeSystem, in the order the questionnaire declared them, with
// one label/value pair per value.
// dt/dd must stay direct children of the dl for the list to be valid.
export default function TerminologyDisplayInput({
  properties
}: TerminologyDisplayInputProps) {
  return (
    <Box as='dl' marginTop='xsmall' marginBottom='small'>
      {properties.flatMap(({ code, label, values }) =>
        values.map((value, index) => (
          <Row key={`${code}-${index}`}>
            <Column as='dt' columns={4}>
              <Text as='span' weight='medium'>
                {label}
              </Text>
            </Column>
            <Column as='dd' columns={8} style={{ margin: '0 0 0.5rem' }}>
              <Text as='span'>{formatValue(value)}</Text>
            </Column>
          </Row>
        ))
      )}
    </Box>
  )
}
